import map from 'lodash/map'
import { PurchaseOrderStatus } from '@ztechapps/purchase-order.common'

export const purchaseOrderStatusOptions = map(PurchaseOrderStatus, (item) => {
  return { label: item.value, value: item.value }
})
